import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import {
    LandmarkPair,
    LandmarkResidual,
    landmarkDisplayName,
} from '~/domain/landmark/landmark';
import { formatMetricCm } from '~/utils/measurementFormat';

export interface LandmarkReadout {
    readonly nameOf: (pair: LandmarkPair, index: number) => string;
    readonly textOf: (residual: LandmarkResidual) => string;
}

export function useLandmarkReadout(): LandmarkReadout {
    const intl = useIntl();

    const nameOf = useCallback(
        (pair: LandmarkPair, index: number) =>
            landmarkDisplayName(pair, index + 1, (ordinal) =>
                intl.formatMessage(
                    { id: 'landmark.defaultName' },
                    { n: ordinal }
                )
            ),
        [intl]
    );

    const textOf = useCallback(
        (residual: LandmarkResidual) =>
            residual.status === 'measured'
                ? formatMetricCm(residual.residualMm)
                : intl.formatMessage({
                      id: `registrationQa.tre.${residual.status}`,
                  }),
        [intl]
    );

    return { nameOf, textOf };
}
